import React, { useState  } from 'react';
import './UploadPageStyle.css';
import axios from 'axios';
import { MdDeleteForever } from "react-icons/md";


function UploadPage({ backgroundImage, brideName, groomName }) {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadFlag, setUploadFlag] = useState(false);
  const MAX_FILES = 100;
const UPLOAD_URL = 'https://moment-share-35b5803454f8.herokuapp.com/upload-to-drive'
  const handleUpload = (event) => {
    const files = Array.from(event.target.files);
    if (files.length + selectedFiles.length > MAX_FILES) {
      alert(`You can only upload a maximum of ${MAX_FILES} files.`);
      return;
    }
    setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    if (selectedFiles.length === 0) {
      setUploadFlag(false);
      console.log('No files selected');
      return;
    } else {
      setUploadFlag(true);
    }

    try {
      // Request pre-signed URLs
      const formData = new FormData();
      selectedFiles.forEach(file => formData.append('files', file));
      

      const uploadPromise = axios.post(UPLOAD_URL, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            setUploadProgress(progress);
          }
        }
      });

      const uploadPromises = [uploadPromise];
      // const presignedResponse = await axios.post('https://moment-share-35b5803454f8.herokuapp.com/generate-presigned-urls', {
      //   files: fileInfos,
      //   brideName,
      //   groomName

      // });

      // const presignedUrls = presignedResponse.data.urls;

      // // Upload files to S3 using pre-signed URLs
      // const uploadPromises = presignedUrls.map(({ fileName, url }, index) => {
      //   const file = selectedFiles[index];
      //   return axios.put(url, file, {
      //     headers: {
      //       'Content-Type': file.type
      //     },
      //     onUploadProgress: (progressEvent) => {
      //       if (progressEvent.lengthComputable) {
      //         const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
      //         setUploadProgress(prevProgress => (prevProgress + progress / selectedFiles.length));
      //       }
      //     }
      //   });
      // });

      await Promise.all(uploadPromises);

      console.log('Upload successful!');
      setUploadProgress(0);
      setSelectedFiles([]);
      setUploadFlag(false);
      alert('Upload successful!');
    } catch (error) {
      console.error('Error uploading files:', error.response ? error.response.data : error.message);
      alert('Error uploading files. Please try again.');
    }
  };
 

  return (
    <div
      className="home-container"
      style={{ backgroundImage: `url(${backgroundImage})`,display:'flex', justifyContent:'center', alignItems:'center' }}
      data-aos="fade-zoom-in"
      data-aos-offset="150"
      data-aos-easing="ease-in-sine"
      data-aos-duration="3000"
    >
      
      <form className="upload-form" onSubmit={handleSubmit}>
        <p className="upload-text">
        Share your view of our love , so we can hold it close forever - capture the moments.
        </p>
        <label className="custom-file-upload">
          <input
            type="file"
            multiple={selectedFiles.length < MAX_FILES}
            accept="image/*,video/*"
            onChange={handleUpload}
          />
          choose file
        </label>
        {uploadFlag && (
          <div className="progress-bar">
            <div className="progress" style={{ width: `${uploadProgress}%` }}></div>
          </div>
        )}
        <div className="selected-files">
          {selectedFiles.map((file, index) => (
            <div key={index} className="file">
              {file.type.startsWith('video') ? (
                <video src={window.URL.createObjectURL(file)} controls={false} />
              ) : (
                <img src={window.URL.createObjectURL(file)} alt={file.name} />
              )}
            
                <div className='delete-icon' onClick={() => {
                  setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
                }}>
               <MdDeleteForever /> 
               </div>
             
            </div>
          ))}
        </div>
        <div className='buttons-container'>
          <button type="submit" className="upload-button">Send</button>
        </div>
      </form>
    </div>
  );
}

export default UploadPage;
